"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var TabEditorContainer_1 = require("../../../../../../../../shared/components/containers/TabEditorContainer");
var BrandPayProviderEditor = /** @class */ (function (_super) {
    __extends(BrandPayProviderEditor, _super);
    function BrandPayProviderEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        return _this;
    }
    BrandPayProviderEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    provider_identity: _item.provider_identity,
                    provider_name: _item.provider_name,
                    provider_system: _item.provider_system,
                    provider_logo: _item.provider_logo,
                    time_to_expire: _item.time_to_expire,
                    min_deposit_amount: _item.min_deposit_amount,
                    max_deposit_amount: _item.max_deposit_amount,
                    is_check_url: _item.is_check_url,
                    order_number: _item.order_number,
                    is_locked: _item.is_locked,
                    is_trusted_only: _item.is_trusted_only,
                    is_mobile: _item.is_mobile,
                    is_desktop: _item.is_desktop,
                    trust_zone_code: _item.trust_zone_code,
                    trust_zone_title: _item.trust_zone_title,
                    is_custom_trusted_amounts: _item.is_custom_trusted_amounts,
                    min_deposit_amount_trusted: _item.min_deposit_amount_trusted,
                    max_deposit_amount_trusted: _item.max_deposit_amount_trusted,
                    min_dep_amount_to_handle_as_trusted: _item.min_dep_amount_to_handle_as_trusted,
                    is_trusted_by_custom_deposit_count: _item.is_trusted_by_custom_deposit_count,
                    min_deposit_count_to_be_trusted: _item.min_deposit_count_to_be_trusted,
                    is_trusted_by_custom_withdraw_count: _item.is_trusted_by_custom_withdraw_count,
                    min_withdraw_count_to_be_trusted: _item.min_withdraw_count_to_be_trusted,
                    description: _item.description,
                    is_use_min_dep_amount_per_day_limit: _item.is_use_min_dep_amount_per_day_limit,
                    min_dep_amount_per_day_limit: _item.min_dep_amount_per_day_limit,
                    is_mark_suspicious_withdraw_on_treshold_dep_amount: _item.is_mark_suspicious_withdraw_on_treshold_dep_amount,
                    treshold_dep_amount_to_mark_suspicious: _item.treshold_dep_amount_to_mark_suspicious,
                    is_randomize_per_day_amount_by_percent: _item.is_randomize_per_day_amount_by_percent,
                    min_dep_amount_limit_randomize_percent: _item.min_dep_amount_limit_randomize_percent,
                    max_dep_amount_limit_randomize_percent: _item.max_dep_amount_limit_randomize_percent,
                    tabKey: this.key_main
                });
            }
        }
        else {
            this.setState({
                app_currency_id: 0,
                app_currency_title: "",
                provider_identity: 0,
                provider_name: "",
                provider_system: "",
                provider_logo: "",
                time_to_expire: 0,
                min_deposit_amount: 0,
                max_deposit_amount: 0,
                is_check_url: false,
                order_number: 0,
                is_locked: false,
                is_trusted_only: false,
                is_mobile: false,
                is_desktop: false,
                trust_zone_code: 0,
                trust_zone_title: "",
                is_custom_trusted_amounts: false,
                min_deposit_amount_trusted: 0,
                max_deposit_amount_trusted: 0,
                min_dep_amount_to_handle_as_trusted: 0,
                is_trusted_by_custom_deposit_count: false,
                min_deposit_count_to_be_trusted: 0,
                is_trusted_by_custom_withdraw_count: false,
                min_withdraw_count_to_be_trusted: 0,
                description: "",
                is_use_min_dep_amount_per_day_limit: false,
                min_dep_amount_per_day_limit: 0,
                is_mark_suspicious_withdraw_on_treshold_dep_amount: false,
                treshold_dep_amount_to_mark_suspicious: 0,
                is_randomize_per_day_amount_by_percent: false,
                min_dep_amount_limit_randomize_percent: 0,
                max_dep_amount_limit_randomize_percent: 0,
                tabKey: this.key_main
            });
        }
        this.doReSetRules();
    };
    BrandPayProviderEditor.prototype.doReSetRules = function () {
        this.setState({
            app_currency_rules: { isError: false },
            provider_name_rules: { isError: false },
            provider_logo_rules: { isError: false },
            trust_zone_rules: { isError: false }
        });
    };
    BrandPayProviderEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.trust_zone_code <= 0) || (this.state.trust_zone_title.length === 0)) {
            this.setState({
                trust_zone_rules: { isError: true, errorMessage: "Зона доверия не выбрана!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.provider_name) || (this.state.provider_name.length === 0)) {
            this.setState({
                provider_name_rules: { isError: true, errorMessage: "Название провайдера не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.provider_system) || (this.state.provider_system.length === 0)) {
            this.setState({
                provider_system_rules: { isError: true, errorMessage: "Система провайдера не заполнена!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.provider_logo) || (this.state.provider_logo.length === 0)) {
            this.setState({
                provider_logo_rules: { isError: true, errorMessage: "Лого провайдера не заполнена!" },
                tabKey: this.key_main
            });
            return false;
        }
        return true;
    };
    BrandPayProviderEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                provider_identity: this.state.provider_identity,
                provider_name: this.state.provider_name,
                provider_system: this.state.provider_system,
                provider_logo: this.state.provider_logo,
                time_to_expire: this.state.time_to_expire,
                min_deposit_amount: this.state.min_deposit_amount,
                max_deposit_amount: this.state.max_deposit_amount,
                is_check_url: this.state.is_check_url,
                is_locked: this.state.is_locked,
                order_number: this.state.order_number,
                is_trusted_only: this.state.is_trusted_only,
                is_mobile: this.state.is_mobile,
                is_desktop: this.state.is_desktop,
                trust_zone_code: this.state.trust_zone_code,
                is_custom_trusted_amounts: this.state.is_custom_trusted_amounts,
                min_deposit_amount_trusted: this.state.min_deposit_amount_trusted,
                max_deposit_amount_trusted: this.state.max_deposit_amount_trusted,
                min_dep_amount_to_handle_as_trusted: this.state.min_dep_amount_to_handle_as_trusted,
                is_trusted_by_custom_deposit_count: this.state.is_trusted_by_custom_deposit_count,
                min_deposit_count_to_be_trusted: this.state.min_deposit_count_to_be_trusted,
                is_trusted_by_custom_withdraw_count: this.state.is_trusted_by_custom_withdraw_count,
                min_withdraw_count_to_be_trusted: this.state.min_withdraw_count_to_be_trusted,
                description: this.state.description,
                is_use_min_dep_amount_per_day_limit: this.state.is_use_min_dep_amount_per_day_limit,
                min_dep_amount_per_day_limit: this.state.min_dep_amount_per_day_limit,
                is_mark_suspicious_withdraw_on_treshold_dep_amount: this.state.is_mark_suspicious_withdraw_on_treshold_dep_amount,
                treshold_dep_amount_to_mark_suspicious: this.state.treshold_dep_amount_to_mark_suspicious,
                is_randomize_per_day_amount_by_percent: this.state.is_randomize_per_day_amount_by_percent,
                min_dep_amount_limit_randomize_percent: this.state.min_dep_amount_limit_randomize_percent,
                max_dep_amount_limit_randomize_percent: this.state.max_dep_amount_limit_randomize_percent
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Платежный провайдер бренда изменен!");
            });
        }
    };
    BrandPayProviderEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.props.rootRecord.key,
                app_currency_id: this.state.app_currency_id,
                provider_identity: this.state.provider_identity,
                provider_name: this.state.provider_name,
                provider_system: this.state.provider_system,
                provider_logo: this.state.provider_logo,
                time_to_expire: this.state.time_to_expire,
                min_deposit_amount: this.state.min_deposit_amount,
                max_deposit_amount: this.state.max_deposit_amount,
                is_check_url: this.state.is_check_url,
                is_locked: this.state.is_locked,
                order_number: this.state.order_number,
                is_trusted_only: this.state.is_trusted_only,
                is_mobile: this.state.is_mobile,
                is_desktop: this.state.is_desktop,
                trust_zone_code: this.state.trust_zone_code,
                is_custom_trusted_amounts: this.state.is_custom_trusted_amounts,
                min_deposit_amount_trusted: this.state.min_deposit_amount_trusted,
                max_deposit_amount_trusted: this.state.max_deposit_amount_trusted,
                min_dep_amount_to_handle_as_trusted: this.state.min_dep_amount_to_handle_as_trusted,
                is_trusted_by_custom_deposit_count: this.state.is_trusted_by_custom_deposit_count,
                min_deposit_count_to_be_trusted: this.state.min_deposit_count_to_be_trusted,
                is_trusted_by_custom_withdraw_count: this.state.is_trusted_by_custom_withdraw_count,
                min_withdraw_count_to_be_trusted: this.state.min_withdraw_count_to_be_trusted,
                description: this.state.description,
                is_use_min_dep_amount_per_day_limit: this.state.is_use_min_dep_amount_per_day_limit,
                min_dep_amount_per_day_limit: this.state.min_dep_amount_per_day_limit,
                is_mark_suspicious_withdraw_on_treshold_dep_amount: this.state.is_mark_suspicious_withdraw_on_treshold_dep_amount,
                treshold_dep_amount_to_mark_suspicious: this.state.treshold_dep_amount_to_mark_suspicious,
                is_randomize_per_day_amount_by_percent: this.state.is_randomize_per_day_amount_by_percent,
                min_dep_amount_limit_randomize_percent: this.state.min_dep_amount_limit_randomize_percent,
                max_dep_amount_limit_randomize_percent: this.state.max_dep_amount_limit_randomize_percent
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Платежный провайдер бренда добавлен!");
            });
        }
    };
    BrandPayProviderEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandPayProviderEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить платежный провайдер бренда";
        }
        else {
            return "Изменить платежный провайдер бренда";
        }
    };
    BrandPayProviderEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Ид провайдера", placeholder: "Введите ид провайдера" }, values: { max: 999999, min: 0, value: this.state.provider_identity }, onValueChanged: function (newVal) {
                    _this.setState({
                        provider_identity: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название провайдера:", placeholder: "Введите название" }, value: this.state.provider_name, onValueChanged: function (newVal) {
                    _this.setState({
                        provider_name: newVal,
                        provider_name_rules: { isError: false }
                    });
                }, required: true, rules: this.state.provider_name_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Сервис провайдера:", placeholder: "Введите систему" }, value: this.state.provider_system, onValueChanged: function (newVal) {
                    _this.setState({
                        provider_system: newVal,
                        provider_system_rules: { isError: false }
                    });
                }, required: true, rules: this.state.provider_system_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Лого провайдера:", placeholder: "Введите лого" }, value: this.state.provider_logo, onValueChanged: function (newVal) {
                    _this.setState({
                        provider_logo: newVal,
                        provider_logo_rules: { isError: false }
                    });
                }, required: true, rules: this.state.provider_logo_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Время жизни", placeholder: "Введите время жизни" }, values: { max: 99999999, min: 1, value: this.state.time_to_expire }, onValueChanged: function (newVal) {
                    _this.setState({
                        time_to_expire: newVal
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин сумма депа", placeholder: "Введите минимальную сумму депозита" }, values: { max: 99999999, min: 1, value: this.state.min_deposit_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_deposit_amount: newVal
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма депа", placeholder: "Введите максимальную сумму депозита" }, values: { max: 99999999, min: 1, value: this.state.max_deposit_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_deposit_amount: newVal
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Номер П/П", placeholder: "Введите номер по порядку" }, values: { max: 999999, min: 1, value: this.state.order_number }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number: newVal
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Зона доверия:", placeholder: "Выберите зону доверия" }, value: { key: this.state.trust_zone_code, value: this.state.trust_zone_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        trust_zone_code: newVal.key,
                        trust_zone_title: newVal.value,
                        trust_zone_rules: { isError: false }
                    });
                }, items: this.props.trust_zones_avail, required: true, rules: this.state.trust_zone_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Проверять url", value: this.state.is_check_url, onChecked: function (checked) { _this.setState({ is_check_url: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Только для доверенных игроков", value: this.state.is_trusted_only, onChecked: function (checked) { _this.setState({ is_trusted_only: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Мобильный", value: this.state.is_mobile, onChecked: function (checked) { _this.setState({ is_mobile: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Десктопный", value: this.state.is_desktop, onChecked: function (checked) { _this.setState({ is_desktop: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            this.getDownButtons()));
    };
    BrandPayProviderEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BrandPayProviderEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Комментарий:", placeholder: "Введите комментарий" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Собственное кол-во депозитов для перехода в статус 'доверенный'", value: this.state.is_trusted_by_custom_deposit_count, onChecked: function (checked) { _this.setState({ is_trusted_by_custom_deposit_count: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во депозитов", placeholder: "Введите количество депозитов" }, values: { max: 99999999, min: 1, value: this.state.min_deposit_count_to_be_trusted }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_deposit_count_to_be_trusted: newVal
                    });
                }, disabled: !this.state.is_trusted_by_custom_deposit_count }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Собственное кол-во снятий для перехода в статус 'доверенный'", value: this.state.is_trusted_by_custom_withdraw_count, onChecked: function (checked) { _this.setState({ is_trusted_by_custom_withdraw_count: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во снятий", placeholder: "Введите количество снятий" }, values: { max: 99999999, min: 1, value: this.state.min_withdraw_count_to_be_trusted }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_withdraw_count_to_be_trusted: newVal
                    });
                }, disabled: !this.state.is_trusted_by_custom_withdraw_count }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Отдельные суммы депозитов для доверенных игроков", value: this.state.is_custom_trusted_amounts, onChecked: function (checked) { _this.setState({ is_custom_trusted_amounts: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин сумма депа", placeholder: "Введите минимальную сумму депозита" }, values: { max: 99999999, min: 1, value: this.state.min_deposit_amount_trusted }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_deposit_amount_trusted: newVal
                    });
                }, disabled: !this.state.is_custom_trusted_amounts }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма депа", placeholder: "Введите максимальную сумму депозита" }, values: { max: 99999999, min: 1, value: this.state.max_deposit_amount_trusted }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_deposit_amount_trusted: newVal
                    });
                }, disabled: !this.state.is_custom_trusted_amounts }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин деп доверия", placeholder: "Введите минимальную сумму для обработки как доверенного" }, values: { max: 99999999, min: 0, value: this.state.min_dep_amount_to_handle_as_trusted }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_dep_amount_to_handle_as_trusted: newVal
                    });
                }, disabled: !this.state.is_custom_trusted_amounts }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Установен лимит депозитов в сутки", value: this.state.is_use_min_dep_amount_per_day_limit, onChecked: function (checked) { _this.setState({ is_use_min_dep_amount_per_day_limit: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма депозитов в сутки", placeholder: "Введите максимально разрешенную сумму депозитов в сутки" }, values: { max: 99999999, min: 0, value: this.state.min_dep_amount_per_day_limit }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_dep_amount_per_day_limit: newVal
                    });
                }, disabled: !this.state.is_use_min_dep_amount_per_day_limit }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Рандомизировать в меньшую сторону лимит депозитов в сутки", value: this.state.is_randomize_per_day_amount_by_percent, onChecked: function (checked) { _this.setState({ is_randomize_per_day_amount_by_percent: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин. % отклонения вниз", placeholder: "Введите минимальный процент отклонения вниз" }, values: { max: 90, min: 1, value: this.state.min_dep_amount_limit_randomize_percent }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_dep_amount_limit_randomize_percent: newVal
                    });
                }, disabled: !this.state.is_randomize_per_day_amount_by_percent }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс. % отклонения вниз", placeholder: "Введите максимальный процент отклонения вниз" }, values: { max: 90, min: 1, value: this.state.max_dep_amount_limit_randomize_percent }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_dep_amount_limit_randomize_percent: newVal
                    });
                }, disabled: !this.state.is_randomize_per_day_amount_by_percent }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Помечать подозрительным при попытке использования этого метода начиная с минимальной суммы", value: this.state.is_mark_suspicious_withdraw_on_treshold_dep_amount, onChecked: function (checked) { _this.setState({ is_mark_suspicious_withdraw_on_treshold_dep_amount: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Минимальная сумма депозита", placeholder: "Введите минимуальную сумму чтобы считать игрока подозрительным" }, values: { max: 99999999, min: 0, value: this.state.treshold_dep_amount_to_mark_suspicious }, onValueChanged: function (newVal) {
                    _this.setState({
                        treshold_dep_amount_to_mark_suspicious: newVal
                    });
                }, disabled: !this.state.is_mark_suspicious_withdraw_on_treshold_dep_amount }),
            this.getDownButtons()));
    };
    BrandPayProviderEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    BrandPayProviderEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        throw "invalid tabkey -> " + this.state.tabKey;
    };
    /*
                <CardEditorContainer
                onGoBackClick={this.OnGoBackClick.bind(this)}
                title={this.getFormTitle()}
                state={this.props.state}
                maxHeight={900}
            >



            </CardEditorContainer>
    
    */
    BrandPayProviderEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 980, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" }
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return BrandPayProviderEditor;
}(React.Component));
exports.default = BrandPayProviderEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/pay_providers/BrandPayProviderEditor.tsx
// module id = 1800
// module chunks = 0